import React from 'react';
import { useTSState } from '../../TSContext';
import PlayIcon from '../icons/play-icon';
const BodyWidget = ({ voiceListFiltered }) => {
    const { state } = useTSState();
    const { selectedText, isPlaying, isTranslating, isGettingAudio, miniPlayer, translatedText } = state;
    const isLoading = isGettingAudio || isTranslating;
    const isTranslateMode = (voiceListFiltered === null || voiceListFiltered === void 0 ? void 0 : voiceListFiltered.length) === 0;
    const getIcon = () => {
        if (isLoading) {
            return React.createElement("div", { className: "ts-img-loading", style: { width: miniPlayer ? 25 : 35 } });
        }
        if (isPlaying) {
            return React.createElement("div", { className: "ts-img-playing", style: { width: miniPlayer ? 25 : 35 } });
        }
        if (isTranslateMode) {
            return React.createElement("div", { className: "ts-img-translate", style: { width: miniPlayer ? 20 : 30 } });
        }
        return React.createElement(PlayIcon, null);
    };
    if (!selectedText) {
        if (miniPlayer) {
            return (React.createElement("div", { className: "tsplayer-player-body-content-mini", style: { textWrap: isTranslateMode ? 'wrap' : 'nowrap' } },
                React.createElement("div", { className: "icon-wrap-mini" }, getIcon()),
                React.createElement("div", { className: "tsplayer-player-selected-wrapper-mini" },
                    React.createElement("div", { className: "tsplayer-player-selected-text" }, `Use Wally's Voice Buddy to translate the text into audio with your preferred language and voice style!`))));
        }
        return (React.createElement("div", { className: "tsplayer-player-body" },
            React.createElement("div", { style: { flex: 0.2 } },
                React.createElement("img", { src: "https://app.dev.kidvestors.co/assets/email-assets/mascot-head.png", alt: "KV Mascot", title: "KV Mascot", style: { width: 150, borderRadius: 50 } })),
            React.createElement("div", { className: "tsplayer-title2" }, `Use Wally's Voice Buddy to translate the text into audio with your preferred language and voice style!`),
            React.createElement("div", { className: "tsplayer-title3" }, "To listen to the text, select the desired amount of text and it will appear in this block")));
    }
    if (miniPlayer) {
        return (React.createElement("div", { className: "tsplayer-player-body-content-mini", style: { textWrap: isTranslateMode ? 'wrap' : 'nowrap' } },
            React.createElement("div", { className: "icon-wrap-mini" }, getIcon()),
            React.createElement("div", { className: "tsplayer-player-selected-wrapper-mini" },
                React.createElement("div", { className: "tsplayer-player-selected-text" }, translatedText || selectedText))));
    }
    return (React.createElement("div", { className: "tsplayer-player-body-content" },
        React.createElement("div", null, getIcon()),
        React.createElement("div", { className: "tsplayer-player-selected-wrapper" },
            React.createElement("div", { className: "tsplayer-player-selected-text" }, translatedText || selectedText))));
};
export default BodyWidget;
